module.exports = __webpack_public_path__ + "img/omega-opcion-2.d0ed6850.png";